const TOOLTIP_BACKGROUND = "rgba(0, 0, 0, 0.85)";
const TOOLTIP_COLOR = "#ffffff";
const TOOLTIP_FONT_SIZE = 13;
const TOOLTIP_RADIUS = 6;
const TOOLTIP_PADDING = 8;
const TOOLTIP_FONT_FAMILY = "Mulish, sans-serif";

export const getChartTooltipOptions = (overrides = {}) => ({
  backgroundColor: TOOLTIP_BACKGROUND,
  titleColor: TOOLTIP_COLOR,
  bodyColor: TOOLTIP_COLOR,
  borderColor: "transparent",
  borderWidth: 0,
  cornerRadius: TOOLTIP_RADIUS,
  padding: TOOLTIP_PADDING,
  displayColors: false,
  titleAlign: "left",
  bodyAlign: "left",
  titleFont: {
    size: TOOLTIP_FONT_SIZE,
    weight: "600",
    family: TOOLTIP_FONT_FAMILY,
  },
  bodyFont: {
    size: TOOLTIP_FONT_SIZE,
    family: TOOLTIP_FONT_FAMILY,
  },
  ...overrides,
});
